"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var ShowType;
(function (ShowType) {
    ShowType["Series"] = "SERIES";
    ShowType["Sport"] = "SPORT";
})(ShowType = exports.ShowType || (exports.ShowType = {}));
//# sourceMappingURL=ShowType.js.map